const TRAFFIC_KEY = 'tff_traffic';
const EVENTS_KEY  = 'tff_events';
const SESSION_KEY = 'tff_session_id';

// ── Session ───────────────────────────────────────────────────────────────────
const getSessionId = () => {
  let sid = sessionStorage.getItem(SESSION_KEY);
  if (!sid) {
    sid = `s_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
    sessionStorage.setItem(SESSION_KEY, sid);
  }
  return sid;
};

// ── Raw accessors ─────────────────────────────────────────────────────────────
const getTrafficData = () => {
  try { return JSON.parse(localStorage.getItem(TRAFFIC_KEY) || '[]'); }
  catch { return []; }
};

const getEventsData = () => {
  try { return JSON.parse(localStorage.getItem(EVENTS_KEY) || '[]'); }
  catch { return []; }
};

// ── Tracking ──────────────────────────────────────────────────────────────────
export const trackPageView = (path) => {
  const views = getTrafficData();
  views.push({ path, sessionId: getSessionId(), ts: Date.now() });
  // Cap at 10 000 entries
  if (views.length > 10000) views.splice(0, views.length - 10000);
  localStorage.setItem(TRAFFIC_KEY, JSON.stringify(views));
};

export const trackEvent = (event, data = {}) => {
  const events = getEventsData();
  events.push({ event, data, sessionId: getSessionId(), ts: Date.now() });
  if (events.length > 5000) events.splice(0, events.length - 5000);
  localStorage.setItem(EVENTS_KEY, JSON.stringify(events));
};

// ── Analytics computations ────────────────────────────────────────────────────
export const getAnalytics = () => {
  const views = getTrafficData();
  const now   = Date.now();
  const DAY   = 86400000;

  const last30 = views.filter(v => v.ts > now - 30 * DAY);
  const last7  = views.filter(v => v.ts > now -  7 * DAY);
  const today  = views.filter(v => v.ts > now -      DAY);

  // Unique sessions
  const sessions30 = new Set(last30.map(v => v.sessionId)).size;

  // Per-page breakdown (last 30d)
  const pageCounts = {};
  last30.forEach(v => { pageCounts[v.path] = (pageCounts[v.path] || 0) + 1; });

  // Daily trend (last 30 days, keyed by YYYY-MM-DD)
  const dailyMap = {};
  for (let i = 29; i >= 0; i--) {
    const key = new Date(now - i * DAY).toISOString().split('T')[0];
    dailyMap[key] = 0;
  }
  last30.forEach(v => {
    const key = new Date(v.ts).toISOString().split('T')[0];
    if (key in dailyMap) dailyMap[key]++;
  });

  const daily = Object.entries(dailyMap).map(([date, count]) => ({ date, count }));
  const avgPerDay = last30.length > 0 ? Math.round((last30.length / 30) * 10) / 10 : 0;

  return {
    totalViews30: last30.length,
    totalViews7:  last7.length,
    todayViews:   today.length,
    sessions30,
    avgPerDay,
    pageCounts,
    daily,
  };
};

// ── Monthly lead helper (used by analytics tab, accepts leads array) ──────────
export const getMonthlyLeads = (leads) => {
  const now = new Date();
  const months = [];
  for (let i = 5; i >= 0; i--) {
    const d    = new Date(now.getFullYear(), now.getMonth() - i, 1);
    const key  = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
    const label = d.toLocaleString('default', { month: 'short' });
    months.push({ key, label, count: 0 });
  }
  leads.forEach(l => {
    const key = l.createdAt ? l.createdAt.slice(0, 7) : null;
    const m   = months.find(m => m.key === key);
    if (m) m.count++;
  });
  return months;
};
